export default "__VITE_ASSET__fe51bceb__"